<template lang="pug">
  a.btn-goTop(href="#app", v-smooth-scroll="{ duration: 1500, offset: 0 }")
    font-awesome-icon(icon="arrow-up")
</template>

<script>
export default {
  name: 'GoTop'
}
</script>

<style lang="sass" scoped>
.btn-goTop
  +fs($ta: center, $c: $c-grey, $fz: 42px, $lh: 52px)
  +pos($p: fixed, $b: 20px, $r: 20px)
  +size($w: 52px, $h: 52px)
  opacity: .5
  cursor: pointer
  z-index: 1
  &:hover
    opacity: .8
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue